import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@src/store';
import { IAnalyticsInitialState } from './types';

const selectAnalyticsReducer = (state: RootState): IAnalyticsInitialState =>
  state.AnalyticsPageReducer;

export const selectAnalyticsState = createSelector(
  [selectAnalyticsReducer],
  (state) => state
);
